module.exports = __webpack_public_path__ + "static/media/forward_arrow_icon.c8431429.svg";